import React from 'react';
import SEO from '../components/SEO';

const AboutPage = () => {
  return (
    <>
      <SEO 
        title="About Us | Trademark Supremacy - Expert Trademark Registration"
        description="Learn about Trademark Supremacy's mission to provide affordable, professional trademark registration services with licensed USPTO attorneys."
        keywords="about trademark registration, USPTO attorneys, trademark services, intellectual property experts"
        canonical="/about"
      />
      <div className="min-h-screen py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-5xl font-bold text-center mb-8">About Trademark Supremacy</h1>
          <p className="text-xl text-gray-600 text-center mb-12">
            Your trusted partner in trademark registration and brand protection
          </p>
          
          <section className="prose prose-lg max-w-none" aria-label="Company information">
            <h2 className="text-3xl font-bold mt-12 mb-4">Our Mission</h2>
            <p className="text-gray-700 mb-6">
              At Trademark Supremacy, we believe every business deserves professional trademark protection. Our mission is to make trademark registration accessible, affordable, and straightforward for entrepreneurs, startups, and established businesses alike.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">Our Expertise</h2>
            <p className="text-gray-700 mb-6">
              With decades of combined experience in intellectual property law, our team of licensed USPTO attorneys has successfully registered thousands of trademarks across all industries. We understand the intricacies of trademark law and use that knowledge to protect your brand effectively.
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">Why Choose Us</h2>
            <ul className="list-disc pl-6 text-gray-700 space-y-3 mb-6">
              <li>Licensed USPTO attorneys handling every filing</li>
              <li>98% success rate in trademark approvals</li>
              <li>Transparent, flat-fee pricing with no hidden costs</li>
              <li>Fast turnaround time (24-48 hours)</li>
              <li>Comprehensive trademark searches and monitoring</li>
              <li>Personalized service and ongoing support</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">Our Commitment</h2>
            <p className="text-gray-700 mb-6">
              We're committed to providing exceptional service at every step of your trademark journey. From initial consultation to final registration and beyond, we're here to ensure your brand receives the legal protection it deserves.
            </p>
          </section>
        </div>
      </div>
    </>
  );
};

export default AboutPage;